import { Component } from '@angular/core';

@Component({
    selector: 'app-update-button',
    templateUrl: './update-button.component.html',
    styleUrls: ['./update-button.component.scss'],
    standalone: false
})
export class UpdateButtonComponent { }
